import React from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';
import { Link } from "react-router-dom";
const Modal = ({ closeModal }) => {
    return ReactDOM.createPortal(
        <div onClick={closeModal} className='modal-overlay'>
            <div
                onClick={(e) => e.stopPropagation()}
                className='modal-container'
            >
                <div className='upper-section'>
                    <h1>Contact me</h1>
                    <p onClick={closeModal} className='close'>
                        &times;
                    </p>
                </div>
                <div className='middle-section'>
                    <p>Gmail: andrewbuestan@gmail.com</p>
                    
                </div>
                <div className='lower-section'>
                    <button onClick={closeModal} className='modal-btn btn-close'>
                        Close
                    </button>
                    <Link className="modal-btn btn-contact" to="/contact">
                        Contact
                    </Link>
                </div>
            </div>
        </div>,
        document.getElementById('modal')
    );
};

export default Modal;